import * as React from 'react'
import Svg, { Path } from 'react-native-svg'
export const ControlServicesIcon = () => (
  <Svg width={40} height={41} viewBox='0 0 40 41' fill='none'>
    <Path
      d='M13.3333 22.4228H23.3333M13.3333 29.0894H26.6666M21.6666 5.7561H8.33331V35.7561H31.6666V15.7561M21.6666 5.7561H23.3333L31.6666 14.0894V15.7561M21.6666 5.7561V12.4228C21.6666 14.0894 23.3333 15.7561 25 15.7561H31.6666'
      stroke='#859CAD'
      strokeWidth={2.5}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </Svg>
)
